import React from 'react'
import { observer } from 'mobx-react'
import AsideModalStore from 'Stores/asideModalStore'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormField from 'components/UI/AsideModal/Form/FormField'

const CancelModal = () => {
  const errorColor = '#db3031'
  const { changeValue, check, modalValues } = AsideModalStore

  return (
    <FormField>
      <FormLabel> Сomment:</FormLabel>
      <textarea
        value={modalValues.comment || ''}
        placeholder={'Comment'}
        onChange={(e) => changeValue(e.target.value, 'comment')}
        style={{ borderColor: check('comment') ? errorColor : '' }}
      />
    </FormField>
  )
}

export default observer(CancelModal)
